import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const Customer = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={0} animateOnce={true} duration={1}>
            <div className="customer">
                <FullWrapper caseName="customer">
                    <CommonSmallText className="customer__text">
                        Наша команда — генеральный подрядчик по digital-маркетингу Технопарка
                        «Сколково».
                    </CommonSmallText>
                </FullWrapper>
            </div>
        </ScrollAnimation>
    );
};

Customer.propTypes = {};

export default Customer;
